import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { StyledTimeline } from './styles.js';
import TimelineItem from './TimelineItem.js';

const Timeline = (_a) => {
    var { items, orientation } = _a, props = __rest(_a, ["items", "orientation"]);
    return (React.createElement(StyledTimeline, Object.assign({ orientation: orientation }, props), items.map((item, index) => (React.createElement(TimelineItem, { key: index, before: item === null || item === void 0 ? void 0 : item.before, after: item === null || item === void 0 ? void 0 : item.after, variation: item === null || item === void 0 ? void 0 : item.variation, customDot: item === null || item === void 0 ? void 0 : item.customDot, orientation: orientation })))));
};

export { Timeline as default };
